import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "../assets/icons/cross-country.svg";
import Phone from "../assets/icons/tel.svg";
import Pin from "../assets/icons/location.svg";
import { ReactComponent as Menu } from "../assets/icons/menu-black.svg";

import SideMenu from "./SideMenu";

const Header = () => {
  const location = useLocation();

  const page = location.pathname.split("/")[1];
  const [showSideNav, setShowSideNav] = useState(false);
  const navLink = [
    {
      name: "about",
      to: "/about",
    },
    {
      name: "courier",
      to: "/courier",
    },
    {
      name: "haulage",
      to: "/haulage",
    },
    {
      name: "transit-hotel",
      to: "/transit-hotel",
    },
    {
      name: "terminal",
      to: "/terminal",
    },
    {
      name: "contact",
      to: "/contact",
    },
  ];
  const onClickMenu = () => {
    setShowSideNav(!showSideNav);
  };
  return (
    <div>
      {showSideNav && <SideMenu onClickMenu={onClickMenu} />}

      <div className="flex  fixed top-0  justify-between items-center  px-4 md:px-10  lg:px-16 w-full z-[8] bg-white border-b">
        <div className="container mx-auto flex py-0 justify-between items-center px-0 md:px-5">
          <div className="flex items-center gap-4">
            <Link to="/" className="border-r pr-3 py-4">
              <img src={Logo} alt="" />
            </Link>
            <div className=" hidden lg:flex items-center font-medium text-sm gap-5 uppercase">
              {navLink.map((item) => (
                <div
                  className="relative cursor-pointer flex flex-col whitespace-nowrap"
                  key={item.to}
                >
                  <NavLink
                    style={({ isActive }) =>
                      isActive
                        ? {
                            fontWeight: "600",
                          }
                        : undefined
                    }
                    to={item.to}
                  >
                    {item.name}
                  </NavLink>
                  <div
                    className={`absolute -bottom-8 w-full h-1  ${
                      page === item.name ? "bg-pry" : ""
                    }`}
                  ></div>
                </div>
              ))}
            </div>
          </div>
          <div className="hidden lg:flex items-center gap-4 font-medium text-sm">
            <div className="flex items-center gap-1 whitespace-nowrap">
              <img src={Phone} alt="" />
              <a href="tel:+234 805 555 5595">+234 805 555 5595</a>
            </div>
            <div className="flex items-center gap-1 whitespace-nowrap">
              <img src={Pin} alt="" />
              <div>Lagos, Nigeria</div>
            </div>
          </div>

          <Menu
            className="block lg:hidden"
            onClick={() => setShowSideNav(!showSideNav)}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
